// The statuses the Workflow status filter leaves unticked on a fresh board, a reset, and a saved
// view that stores no statuses. They are drawn under an OFF BY DEFAULT rule in the filter list
// whether or not they are ticked. Names, not uids: the planner's status filter is name-based.
export const OFF_BY_DEFAULT_STATUSES = [
  "Draft",
  "Archived",
  "Quote",
  "Picked Up",
  "Installed",
  "Delivered",
];
